import React from 'react';
import PropTypes from 'prop-types';

import OptionsStepContainer from '../copied/OptionsStepContainer';
import Options from '../copied/Options';
import Option from '../copied/Option';
import I18nMessage from '../I18nMessage';

import Service from '../../../services/Service';
import Link from '../elements/Link';
import RowContainer from '../elements/RowContainer';

import '../../styles.css';

End.propTypes = {
  previousStep: PropTypes.object,
  step: PropTypes.object,
  steps: PropTypes.object,
  triggerNextStep: PropTypes.func,

  hasClose: PropTypes.bool,
  closeLabel: PropTypes.string,
};

function End({triggerNextStep,hasClose,closeLabel}) {

  // app service
  const myService = Service.getInstance();

  const handleClose = () => {
    setTimeout(() => {
      // on passe par le end du plugin pour qu'il vide son cache
      const nextIntentInstructions = {value:undefined, trigger: 'plugin_end'};
      triggerNextStep(nextIntentInstructions);

      // on vide nos stockages
      myService.reset();

      // on refresh l'encart
      // document.querySelector('#bostik-chatbot .rsc-header a.rsc-header-close-button').click();
      myService.generateGlobalKey();
    }, 100);
  }

  return (
    <RowContainer align={'start'}>
      <I18nMessage labelKey={'label.endMessage'} />
      <RowContainer align={'center'}>
        <OptionsStepContainer className="rsc-os">
          <Options className="rsc-os-options">
            <Option className="rsc-os-option">
              <Link title={hasClose ? closeLabel : 'x'} onClick={handleClose} variant="reset"/>
            </Option>
          </Options>
        </OptionsStepContainer>
      </RowContainer>
    </RowContainer>
  );
}

export default End;
